import React, { Component, Fragment } from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import axios from 'axios';
import config from '../config';

class SecurityQuestionsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            answers: props.preselectedQuestions || [
                { questionId: '', answer: '' },
                { questionId: '', answer: '' },
                { questionId: '', answer: '' }
            ],
            allQuestions: []
        };
    }

    componentDidMount() {

        axios.get(`${config.baseURL}/securityquestions`).then((res) => {
            this.setState({ allQuestions: res.data });
        });
    }

    handleChange = (index, field, value) => {
        const answers = [...this.state.answers];
        answers[index][field] = value;
        this.setState({ answers });
    };

    getAnswers = () => {
        return this.state.answers.map(({ questionId, answer }) => ({
            question_id: questionId,
            answer
        }));
    };

    render() {
        const { verifyMode } = this.props;

        return (
            <div>
                {!verifyMode && (
                    <p className="text-muted">
                        Please select and answer 3 unique questions.
                        <br />
                        <strong>Don’t use answers others could guess easily.</strong>
                    </p>
                )}

                {this.state.answers.map((entry, i) => (
                    <FormGroup key={i}>
                        <ControlLabel>Question {i + 1}</ControlLabel>
                        <FormControl
                            componentClass="select"
                            value={entry.questionId}
                            disabled={verifyMode}
                            onChange={(e) =>
                                this.handleChange(i, 'questionId', parseInt(e.target.value))
                            }
                        >
                            <option value="">Select a question</option>
                            {this.state.allQuestions.map((q) => (
                                <option key={q.id} value={q.id}>
                                    {q.question}
                                </option>
                            ))}
                        </FormControl>
                        <FormControl
                            type="text"
                            placeholder="Your answer"
                            value={entry.answer}
                            onChange={(e) => this.handleChange(i, 'answer', e.target.value)}
                        />
                    </FormGroup>
                ))}
            </div>
        );
    }
}

export default SecurityQuestionsForm;
